import React, { Component } from "react";
import AccountSettingJsx from "./accountSetting.jsx";
import {
  baseURL, uploadURL
} from "../../../../constants/applicationConstants.js";
import axios from 'axios'
import { Loader } from '../../../common/loader/loader.jsx';
import { nameRegex, websiteRegex, allRegex, emailRegex, postalCodeRegex, alphaNumericRegex } from "../../../../shared/helper.js";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';

export class AccountSettingJsxclass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        institutionName: "",
        legalInstitutionName: "",
        institutionEmail: "",
        confirmInstitutionEmail: "",
        segment: "",
        category: null,
        sizeOfInstitution: "",
        dateOfIncorporation: null,
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        postalCode: "",
        province: "",
        provinceSection: null,
        countryName: null,
        city: "",
        country: "",
        street: "",
        licenseNo: "",
        regulatory: "",
        institutionalContact: "",
        customerContact: "",
        website: "",
        facebook: "",
        insta: "",
        twitter: "",
        linkedin: "",
        tempCat: null
      },
      provinceList: null,
      countryList: null,
      sizeList: null,
      segmentList: null,
      categoryList: null,
      isProcessing: false,
      formError: {},
      editInstitite: false,
      editLogo: false,
      editContact: false,
      editAddress: false,
      editOther: false,
      editSocial: false,
      formSubmitButtonDisable: true,
      isLoading: false,
      _URL: window.URL || window.webkitURL,
      image: null,
      imageName: null,
      imageUrl: "",
      fileInfo: null,
      profileImagePreviewUrl: null,
      isEditMode: false,
      responseData: null
    };

  }
  onNextButtonClick1 = () => {
    this.setState({
      isLoading: true
    })

    let image = this.state.image;

    const payloadData1 = {
      imageUrl: image
    }

    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    let instituteId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))



    if (instituteId) {
      axios.put(`${baseURL}/institute/${instituteId}/account`, payloadData1, {
        headers: { 'x-access-token': token }
      }).then(res => {
        if (res.data.success) {
          toast.success("Data Updated Successfully!")
          this.setState({
            isLoading: false
          })
          this.setState({ editLogo: false })
          this.setState({ profileImagePreviewUrl: null })
          this.callDetails()
          window.location.reload()
        }
        else {
          toast.error(res.data.error.message)
          this.setState({
            isLoading: false
          })
        }

      }).catch(err => {
        toast.error(err.response.data.error.message)
        this.setState({
          isLoading: false
        })
      })
    }
  }

  onNextButtonClick = () => {
    this.setState({
      isLoading: true
    })
    let formData1 = new FormData();

    if (this.state.fileInfo) {
      formData1.append('image', this.state.fileInfo)
      formData1.append('imageCategory', "institute")

      axios.post(`${uploadURL}/upload-file`, formData1).then(resp => {
        if (resp.status === 200) {
          this.setState({ image: resp.data.filename })
          toast.success("Image uploaded successfully");
          setTimeout(() => {
            this.onNextButtonClick1()
          }, 2000)
        }
      }).catch(() => {
        this.setState({
          isLoading: false
        })
      })
    }
    else this.onNextButtonClick1();
  };

  componentDidMount = () => {
    this.setState({ isLoading: true })
    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    let instituteId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))
    if (!token) {
      this.props.history.push("/");
    }
    if (token && instituteId) {
      this.callDetails()
    }


    // next part
    axios.get(`${baseURL}/instituteSegments`).then(res => {
      this.getUpdateJSON('segment', res.data.data);

      let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"));
      let instituteId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"));

      if (token && instituteId) {
        const category = res.data.data.filter(item => item.institutionSegmentId === 1)[0]?.institutionCategories;
        this.getUpdateJSON('category', category);

        let tempArr = [];

        category?.forEach(cat => {
          this.state.formData.tempCat?.forEach(abc => {
            if (cat.institutionCategoryId === abc.institutionCategoryId) {
              tempArr.push({ label: cat.name, value: cat.institutionCategoryId });
            }
          });
        });

        this.setState({
          formData: { ...this.state.formData, category: [...tempArr] }
        });
      }
    });


    axios.get(`${baseURL}/countries`).then(res => {
      this.getUpdateJSON('country', res.data.data);
    })

    axios.get(`${baseURL}/states`).then(res => {
      this.getUpdateJSON('province', res.data.data);
      // this.setState({provinceList: res.data.data})
    })

    axios.get(`${baseURL}/institutionSizes`).then(res => {
      this.getUpdateJSON('sizeOfInstitution', res.data.data);
      this.setState({ isLoading: false })
    })
  }
  changeHideState = (action) => {
    this.setState({ editInstitite: action })
    this.setState({ formError: {} })
    if (action === false) {
      this.callDetails()
    }
    // this.setState({formData: {}})
  }
  changeLogoState = (action) => {
    this.setState({ editLogo: action })
    this.setState({ formError: {} })
    if (action === false) {
      this.callDetails()
    }
  }
  changeContactState = (action) => {
    this.setState({ editContact: action })
    this.setState({ formError: {} })
    if (action === false) {
      this.callDetails()
    }
  }
  changeSocialState = (action) => {
    this.setState({ editSocial: action })
    this.setState({ formError: {} })
    if (action === false) {
      this.callDetails()
    }
  }
  changeAddressState = (action) => {
    this.setState({ editAddress: action })
    this.setState({ formError: {} })
    if (action === false) {
      this.callDetails()
    }
  }
  changeOtherState = (action) => {
    this.setState({ editOther: action })
    this.setState({ formError: {} })
    if (action === false) {
      this.callDetails()
    }
  }
  getUpdateJSON = (label, values) => {
    if (!Array.isArray(values)) return;

    if (label === 'segment') {
      const dropdownOptions = values.map(value => ({
        label: value.name,
        value: value.institutionSegmentId,
        category: value.institutionCategories
      }));
      this.setState({ segmentList: dropdownOptions });
    } else if (label === 'category') {
      const dropdownOptions = values.map(value => ({
        label: value.name,
        value: value.institutionCategoryId
      }));
      this.setState({ categoryList: dropdownOptions });
    } else if (label === 'sizeOfInstitution') {
      const dropdownOptions = values.map(value => ({
        label: value.size,
        value: value.institutionSizeId
      }));
      this.setState({ sizeList: dropdownOptions });
    } else if (label === 'country') {
      const dropdownOptions = values.map(value => ({
        label: value.name,
        value: value.countryCode
      }));
      this.setState({ countryList: dropdownOptions });
    } else if (label === 'province') {
      const dropdownOptions = values.map(value => ({
        label: value.name,
        value: value.stateCode
      }));
      this.setState({ provinceList: dropdownOptions });
    }
  };

  callDetails = () => {
    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    let instituteId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))
    axios.get(`${baseURL}/institute/${instituteId}/details`, {
      headers: { 'x-access-token': token }
    }).then(res => {
      const { name, legalName, email, confirmEmail, institutionSegmentId, instituteSizeId, primaryInstituteUser, postalCode,
        stateCode, city, countryCode, address, regulatoryAssociation, contactNumber, customerCareNumber, website,
        socialMedia, instituteLicenses, instituteCategories, incorporationDate, state, country, imageUrl } = res.data.data;
      const { firstName, lastName } = primaryInstituteUser;

      const { facebookUrl, instagramUrl, linkedinUrl, twitterUrl } = socialMedia;

      const date = incorporationDate.split('-');
      this.setState({ responseData: res.data.data })
      this.setState({
        formData: {
          institutionName: name,
          legalInstitutionName: legalName,
          institutionEmail: email,
          confirmInstitutionEmail: confirmEmail || email,
          segment: institutionSegmentId,
          tempCat: instituteCategories,
          sizeOfInstitution: instituteSizeId,
          dateOfIncorporation: {
            day: parseInt(date[2]),
            month: parseInt(date[1]),
            year: parseInt(date[0])
          },
          provinceSection: state,
          countryName: country,
          firstName: firstName,
          lastName: lastName,
          email: primaryInstituteUser.email,
          phone: primaryInstituteUser.contactNumber,
          postalCode: postalCode,
          province: stateCode,
          city: city,
          country: countryCode,
          street: address,
          licenseNo: instituteLicenses?.map(x => x.licenseNumber)?.join(','),
          regulatory: regulatoryAssociation,
          institutionalContact: contactNumber,
          customerContact: customerCareNumber,
          website: website,
          facebook: facebookUrl,
          insta: instagramUrl,
          twitter: twitterUrl,
          linkedin: linkedinUrl
        },
        isLoading: false,
        isEditMode: true,
        imageUrl: imageUrl,
      })
      this.setState({ isLoading: false })
    })
  }
  getProperPhoneNumber = (value) => {

    if (!isNaN(value)) {
      return value
    }

    const number = value.split(' ');
    return number[0].replace('(', '').replace(')', '') + number[1] + number[2]
  }
  inputRegexValidation = (name, value) => {

    if (name === "institutionName") {
      return alphaNumericRegex.test(value);
    } else if (name === "benefits") {
      return nameRegex.test(value);
    }
    else if (name === "feature") {
      return nameRegex.test(value);
    }
    else if (name === "street") {
      return allRegex.test(value);
    }
    else if (name === 'licenseNo' || name === "regulatory") {
      return alphaNumericRegex.test(value);
    }
    else if (name === "postalCode") {
      return postalCodeRegex.test(value);
    }
    else if (name === "website")
      return websiteRegex.test(value);
    else if (name === "description") {
      return nameRegex.test(value);
    } else if (name === "email" || name === "institutionEmail" || name === "confirmInstitutionEmail") {
      return emailRegex.test(value);
    } else if (name === "phone" || name === "institutionalContact" || name === "customerContact") {
      return !this.getProperPhoneNumber(value).includes('_');
    }
    else if (name === 'facebook')
      return value.includes('facebook')
    else if (name === 'insta')
      return value.includes('instagram')
    else if (name === 'twitter')
      return (value.includes('twitter') || value.includes('x.'))
    else if (name === 'linkedin')
      return value.includes('linkedin')

    else {
      return nameRegex.test(value)
    }
  };

  onInputChangeHandler = (e) => {
    let token = JSON.parse(localStorage.getItem('token'));

    let name = e.target.name;
    let value = e.target.value;

    if (name === "category") {
      this.getSubCategories(value)
    }
    if (name === "subCategory") {
      this.setState({ isLoading: true })
      axios.get(`${baseURL}/productTypes?institutionSubCategoryId=${value}`, {
        headers: { 'x-access-token': token }
      }).then(res => {
        this.setState({ productTypes: res.data.data })
        this.setState({ isLoading: false })

      })
    }
    if (value) {
      if (!this.inputRegexValidation(name, value)) {
        this.setState(
          {
            formData: {
              ...this.state.formData,
              [name]: value,
            },
            formError: {
              ...this.state.formError,
              [name]: "regx",
            },
          },
          () => this.isFromSubmissionBlock()
        );
      } else {
        this.setState(
          {
            formData: {
              ...this.state.formData,
              [name]: value,
            },
            formError: {
              ...this.state.formError,
              [name]: "",
            },
          },
          () => this.isFromSubmissionBlock()
        );
      }
    } else {
      this.setState(
        {
          formData: {
            ...this.state.formData,
            [name]: value,
          },
          formError: {
            ...this.state.formError,
            [name]: "",
          },
        },
        () => this.isFromSubmissionBlock()
      );
    }
  };
  onTouchHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (value === "") {
      this.setState({
        formError: {
          ...this.state.formError,
          [name]: "req",
        },
      });
    } else {
      if (!this.inputRegexValidation(name, value)) {
        this.setState({
          formError: {
            ...this.state.formError,
            [name]: "regx",
          },
        });
      }
    }
  };
  handleChange = (e, name) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [name]: e.value,
          category: []
        },
        formError: {
          ...this.state.formError,
          [name]: "regx",
        },
      },
      () => this.isFromSubmissionBlock()
    );
  }
  isFromSubmissionBlock = () => {
    let { institutionName, legalInstitutionName, sizeOfInstitution } = this.state.formData;

    if (institutionName && legalInstitutionName && sizeOfInstitution) {

      if (
        this.inputRegexValidation("institutionName", institutionName) &&
        this.inputRegexValidation("legalInstitutionName", legalInstitutionName) &&
        this.inputRegexValidation("sizeOfInstitution", sizeOfInstitution)
      ) {
        this.setState({
          formSubmitButtonDisable: false,
        });
      } else {
        this.setState({
          formSubmitButtonDisable: true,
        });
      }
    } else {
      this.setState({
        formSubmitButtonDisable: true,
      });
    }
  };
  onDateChange = (date) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dateOfIncorporation: date,
        }
      },

    );
  }
  getProperPhoneNumber = (value) => {

    if (!isNaN(value)) {
      return value
    }

    const number = value.split(' ');
    return number[0].replace('(', '').replace(')', '') + number[1] + number[2]
  }
  onSubmitButtonClick = () => {
    this.setState({
      isLoading: true
    })
    const { facebook, insta, twitter, linkedin } = this.state.formData;
    const socialPayload = {
      "instagramUrl": insta,
      "facebookUrl": facebook,
      "twitterUrl": twitter,
      "linkedinUrl": linkedin,
    }
    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    let instituteId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))


    axios.put(`${baseURL}/institute/${instituteId}/socialMedia`, socialPayload, {
      headers: { 'x-access-token': token }
    }).then(res => {
      if (res.data.success) {
        toast.success("Data Updated Successfully!")
        this.setState({
          isLoading: false
        })
        this.setState({ editSocial: false })
        this.callDetails()
      }
      else {
        toast.error(res.data.error.message)
        this.setState({
          isLoading: false
        })
      }

    }).catch(err => {
      toast.error("something went wrong")
      this.setState({
        isLoading: false
      })
    })


  }
  onInstituteButtonClick = () => {
    this.setState({
      isLoading: true
    })
    const { institutionName, sizeOfInstitution } = this.state.formData;

    const instituteDetailsPayload = {
      "name": institutionName,
      // "email": institutionEmail,
      // "legalName": legalInstitutionName,
      // "institutionSegmentId": segment,
      "instituteSizeId": sizeOfInstitution,
      // "incorporationDate": dateOfIncorporation && `${dateOfIncorporation?.year}-${getProperDateMonth(dateOfIncorporation?.month)}-${getProperDateMonth(dateOfIncorporation.day)}`,
      // "instituteCategories": category?.map(cat => cat.value),
    }
    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    let instituteId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))
    axios.put(`${baseURL}/institute/${instituteId}/account`, instituteDetailsPayload, {
      headers: { 'x-access-token': token }
    }).then(res => {
      if (res.data.success) {
        toast.success("Data Updated Successfully!")
        this.setState({
          isLoading: false
        })
        this.setState({ editInstitite: false })
        this.callDetails()
      }
      else {
        toast.error(res.data.error.message)
        this.setState({
          isLoading: false
        })
      }

    }).catch(err => {
      toast.error("something went wrong")
      this.setState({
        isLoading: false
      })
    })


  }
  onContactButtonClick = () => {
    this.setState({
      isLoading: true
    })
    const { firstName, lastName, email, phone } = this.state.formData;

    const primaryUserPayload = {
      "firstName": firstName,
      "lastName": lastName,
      "email": email,
      "contactNumber": this.getProperPhoneNumber(phone)
    }
    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    let instituteId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))
    axios.put(`${baseURL}/institute/${instituteId}/primaryUser`, primaryUserPayload, {
      headers: { 'x-access-token': token }
    }).then(res => {
      if (res.data.success) {
        toast.success("Data Updated Successfully!")
        this.setState({
          isLoading: false
        })
        this.setState({ editContact: false })
        this.callDetails()
      }
      else {
        toast.error(res.data.error.message)
        this.setState({
          isLoading: false
        })
      }

    }).catch(err => {
      toast.error(err.response.data.error.message)
      this.setState({
        isLoading: false
      })
    })


  }
  onAddressButtonClick = () => {
    this.setState({
      isLoading: true
    })
    const { city, postalCode, street, province, country } = this.state.formData;

    const registerAddPayload = {
      "address": street,
      "city": city,
      "stateCode": province,
      "countryCode": country,
      "postalCode": postalCode.toString(),
    }
    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    let instituteId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))
    axios.put(`${baseURL}/institute/${instituteId}/account`, registerAddPayload, {
      headers: { 'x-access-token': token }
    }).then(res => {
      if (res.data.success) {
        toast.success("Data Updated Successfully!")
        this.setState({
          isLoading: false
        })
        this.setState({ editAddress: false })
        this.callDetails()
      }
      else {
        toast.error(res.data.error.message)
        this.setState({
          isLoading: false
        })
      }

    }).catch(err => {
      toast.error(err.response.data.error.message)
      this.setState({
        isLoading: false
      })
    })


  }

  onOthersButtonClick = () => {
    this.setState({
      isLoading: true
    })
    const { regulatory, institutionalContact, customerContact, website, licenseNo } = this.state.formData;

    const othersPayload = {
      "regulatoryAssociation": regulatory,
      "contactNumber": this.getProperPhoneNumber(institutionalContact),
      "customerCareNumber": this.getProperPhoneNumber(customerContact),
      "website": website,
      "licenseNumber": licenseNo,
    }
    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    let instituteId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))
    axios.put(`${baseURL}/institute/${instituteId}/account`, othersPayload, {
      headers: { 'x-access-token': token }
    }).then(res => {
      if (res.data.success) {
        toast.success("Data Updated Successfully!")
        this.setState({
          isLoading: false
        })
        this.setState({ editOther: false })
        this.callDetails()
      }
      else {
        toast.error(res.data.error.message)
        this.setState({
          isLoading: false
        })
      }

    }).catch(err => {
      toast.error("something went wrong")
      this.setState({
        isLoading: false
      })
    })


  }

  validFileName = (name) => name.includes('.jpeg') || name.includes('.jpg') || name.includes('.png');

  onFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);

    if (e.target.files[0]?.size) {
      if (e.target.files[0]?.size < 512000) {
        if (e.target.files[0] && this.validFileName(e.target.files[0].name)) {
          if (e.target.files[0] && this.validFileName(e.target.files[0].name)) {
            reader.onloadend = () => {
              const img = new Image();
              img.src = reader.result;

              img.onload = () => {
                const { width, height } = img;

                // Check if the dimensions are exactly 800x800 px                            
                if (width / height === 1) {
                  this.setState({ fileInfo: e.target.files[0] }, () => this.isFromSubmissionBlock())
                  this.setState({ profileImagePreviewUrl: URL.createObjectURL(e.target.files[0]) })
                  this.setState({ imageName: e.target.files[0].name })
                } else {
                  e.target.value = null
                  toast.error('Image must have exactly 1:1 ratio.');
                }
              };
            };
          }
          else {
            toast.error('.jpeg/.jpg/.png format required');
          }




        }
        else
          toast.error('.jpeg/.jpg/.png format required')
      }
      else
        toast.error('File should be less than 500 kb.')
    }
  }

  render() {

    return (
      <div>

        <AccountSettingJsx
          formData={this.state.formData}
          responseData={this.state.responseData}
          onInputChangeHandler={this.onInputChangeHandler}
          onSubmitButtonClick={this.onSubmitButtonClick}
          onInstituteButtonClick={this.onInstituteButtonClick}
          onContactButtonClick={this.onContactButtonClick}
          onAddressButtonClick={this.onAddressButtonClick}
          onOthersButtonClick={this.onOthersButtonClick}
          provinceList={this.state.provinceList}
          countryList={this.state.countryList}
          sizeList={this.state.sizeList}
          handleChange={this.handleChange}
          formError={this.state.formError}
          onDateChange={this.onDateChange}
          changeHideState={this.changeHideState}
          segmentList={this.state.segmentList}
          categoryList={this.state.categoryList}
          editInstitite={this.state.editInstitite}
          editLogo={this.state.editLogo}
          editOther={this.state.editOther}
          editContact={this.state.editContact}
          editSocial={this.state.editSocial}
          editAddress={this.state.editAddress}
          changeAddressState={this.changeAddressState}
          changeContactState={this.changeContactState}
          changeLogoState={this.changeLogoState}
          changeOtherState={this.changeOtherState}
          changeSocialState={this.changeSocialState}
          onTouchHandler={this.onTouchHandler}
          formSubmitButtonDisable={this.state.formSubmitButtonDisable}
          imgURL={this.state.imageUrl}
          onFileChange={this.onFileChange}
          imageName={this.state.imageName}
          onNextButtonClick={this.onNextButtonClick}
          profileImagePreviewUrl={this.state.profileImagePreviewUrl}
        />
        {this.state.isLoading && <Loader />}
        <ToastContainer />
      </div>
    );
  }
}

export default AccountSettingJsxclass;
